import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import './assets/css/theme.scss'
import "abcjs/abcjs-audio.css";
import Vue2TouchEvents from 'vue2-touch-events';

Vue.config.productionTip = false;
Vue.use(require('vue-shortkey'), { prevent: ['input', 'textarea'] });
Vue.use(Vue2TouchEvents);

router.beforeEach((to, from, next) => {
	let direction = "none";
	if (to && to.meta.index !== undefined && from && from.meta.index !== undefined) {
		if (to.meta.index > from.meta.index) {
			if (to.meta.transition && to.meta.transition.forward)
				direction = to.meta.transition.forward;
			else
				direction = "slide-left";
		} else {
			if (to.meta.transition && to.meta.transition.back)
				direction = to.meta.transition.back;
			else
				direction = "slide-right";
		}
	}
	store.dispatch("setTransition", { direction: direction });
	next();
});

router.afterEach((to, from) => {
	// we need this because if we go to part two, then the component doesn't change and we don't get initialized without watching.
	store.dispatch("setCurrentRoute", to.name);
});

new Vue({
	router,
	store,
	render: h => h(App),
	created: function () {
		store.dispatch('setRouter', router);
	}
}).$mount('#app');

window.addEventListener("storage", function (event) {
	if (event.key === "route" && event.newValue !== store.getters.currentRoute)
		router.push({ name: event.newValue});
}, false);
